
export function clamp(min: number, max: number, value: number, defaultValue?: number): number {
	return value ? Math.min(Math.max(value, min), max) : defaultValue;
}

export function toFixed(value:number, fractionDigits: number){
	return value.toFixed(fractionDigits);
}


// WEBPACK FOOTER //
// ./src/core/util/MathUtils.ts